export interface RemoteShellWebComponentSchema {
  hasError: boolean;
}

export const OPERATING_SYSTEM_WINDOWS = 3;
export const OPERATING_SYSTEM_LINUX = 4;

export const PREPARING_DOWNLOAD = 'preparing-download';

export const RemoteShellErrorCodes = {
  INTERNAL_ERROR_DOWNLOAD_REQUEST_FAILED: -10,
  INTERNAL_ERROR_GET_CURRENT_PATH_REQUEST_FAILED: -11,
};
